module.exports = __webpack_public_path__ + "static/media/om.f1bb8fdf.svg";